import React from "react";
import style from "./Navbar.module.css";
import { FcNews } from "react-icons/fc";

const Navbar = () => {
  return (
    <nav className={style.navbar}>
      <div className={style.left}>
        <div className={style.logo}>
          <FcNews color="#FF7433" size="2.5em" />
        </div>
        <h3>News Cafe</h3>
      </div>
      <div className={style.right}>
        <ul>
          <li>Home</li>
          <li>Services</li>
          <li>About</li>
          <li>Features</li>
          <li>Subscription</li>
          <li className={style.active}>Download</li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
